import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { DatePicker, Form, Select } from 'antd';
import { connect } from 'dva';
import { SelectInput } from '../../../../index';
import BottomActions from './BottomActions';
import styles from '../styles.less';

const FormItem = Form.Item;

function CRMInformation({ intl, form, data, currentProject, pipelines, assignees, onSubmit, goPrevStep }) {
  const [dealStages, setDealStages] = useState([]);
  const { getFieldDecorator } = form;
  const initialOutreachEmailWithAiModel = data.peoples.length && 'outreach_email_with_ai_model' in data ? data.outreach_email_with_ai_model : false;

  const handleSubmit = (e) => {
    e.preventDefault();

    form.validateFields((err) => {
      if (!err) {
        onSubmit(form.getFieldsValue());
      }
    });
  };

  const filterOption = (inputValue, option) => {
    return option.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
  };

  const goBack = () => {
    goPrevStep(form.getFieldsValue());
  };

  useEffect(() => {
    const pipeline = pipelines.find(p => p.id === form.getFieldValue('hubspot_pipeline'));
    setDealStages(pipeline ? pipeline.stages : []);
  }, [form.getFieldValue('hubspot_pipeline')]);

  return (
    <Form onSubmit={handleSubmit}>

      {/* Assignee */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.AssigneeLabel" />}
        className={styles.formItem}
      >
        {getFieldDecorator('assignee', {
          initialValue: data.assignee,
          rules: [{
            required: true,
            message: intl.formatMessage({ id: 'Common.Field.Required' }),
          }],
        })(
          <Select
            showSearch
            showArrow
            filterOption={filterOption}
          >
            {assignees.map((c) => {
              return (
                <Select.Option
                  key={c.hubspot_user_id}
                  value={c.hubspot_user_id}
                  title={`${c.first_name} ${c.last_name}`}
                >
                  {c.first_name} {c.last_name}
                </Select.Option>
              );
            })}
          </Select>,
        )}
      </FormItem>
      {/* Due Date */}
      <FormItem
        style={{ display: currentProject.hubspot_create_tasks ? 'block' : 'none' }}
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.DueDateLabel" />}
        className={styles.formItem}
      >
        {getFieldDecorator('due_date', {
          initialValue: data.due_date,
          disabled: !currentProject.hubspot_create_tasks,
          rules: [{
            required: currentProject.hubspot_create_tasks,
            message: intl.formatMessage({ id: 'Common.Field.Required' }),
          }],
        })(
          <DatePicker
            style={{ width: '100%' }}
          />,
        )}
      </FormItem>

      {/* Pipeline */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.Pipeline" />}
        style={{ display: currentProject.hubspot_create_deals ? 'block' : 'none' }}
        className={styles.formItem}
      >
        {getFieldDecorator('hubspot_pipeline', {
          initialValue: data.hubspot_pipeline,
          disabled: currentProject.hubspot_create_deals === false,
          rules: [{
            required: currentProject.hubspot_create_deals,
            message: intl.formatMessage({ id: 'Common.Field.Required' }),
          }],
        })(
          <SelectInput
            showArrow
            options={pipelines}
            onChange={() => {
              form.setFieldsValue({
                hubspot_dealstage: null,
              });
            }}
          />,
        )}
      </FormItem>

      {/* Deal Stage */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.DealStage" />}
        style={{ display: currentProject.hubspot_create_deals ? 'block' : 'none' }}
        className={styles.formItem}
      >
        {getFieldDecorator('hubspot_dealstage', {
          initialValue: data.hubspot_dealstage,
          disabled: currentProject.hubspot_create_deals === false,
          rules: [{
            required: currentProject.hubspot_create_deals,
            message: intl.formatMessage({ id: 'Common.Field.Required' }),
          }],
        })(
          <SelectInput
            showArrow
            options={dealStages}
          />,
        )}
      </FormItem>

      {/* AI Summary */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.AISummary" />}
        className={styles.formItem}
      >
        {getFieldDecorator('enrich_deal_description_with_ai_model', {
          initialValue: 'enrich_deal_description_with_ai_model' in data ? data.enrich_deal_description_with_ai_model : false,
          rules: [{
            required: false,
          }],
        })(
          <SelectInput
            showArrow
            options={[
              { id: true, name: <FormattedMessage id="Common.Yes" /> },
              { id: false, name: <FormattedMessage id="Common.No" /> },
            ]}
          />,
        )}
      </FormItem>

      {/* AI Outreach email */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.OutreachEmail" />}
        className={styles.formItem}
      >
        {getFieldDecorator('outreach_email_with_ai_model', {
          initialValue: initialOutreachEmailWithAiModel,
          rules: [{
            required: false,
          }],
        })(
          <SelectInput
            disabled={!data.peoples.length}
            showArrow
            options={[
              { id: true, name: <FormattedMessage id="Common.Yes" /> },
              { id: false, name: <FormattedMessage id="Common.No" /> },
            ]}
          />,
        )}
      </FormItem>

      <BottomActions goBack={goBack} backSuffix={'Back'} nextSuffix={'Submit'} />
    </Form>
  );
}

CRMInformation.propTypes = {
  data: PropTypes.object,
  currentProject: PropTypes.object,
  pipelines: PropTypes.array,
  assignees: PropTypes.array,
  onSubmit: PropTypes.func,
  goPrevStep: PropTypes.func,
};

export default connect()(Form.create()(injectIntl(CRMInformation)));



// WEBPACK FOOTER //
// ./src/components/Leads/Hubspot/CreateHubspotTransferModal/components/CRMInformation.js